import { computed, ref } from "vue";

/** 경로 비교할 노선을 관리 */
export const useCheckedLineIds = (maxCheckedCount: number) => {
  const checkedLineIds = ref<string[]>([]);
  const checkedLineCount = computed(() => checkedLineIds.value.length);

  const isPossibleToShowLinePath = computed(() => checkedLineCount.value > 0);
  const isPossibleToCheckLine = computed(
    () => checkedLineCount.value < maxCheckedCount
  );

  /** 경로 비교할 노선 체크 관리 */
  const handleCheckLineInfoRow = (targetId: string) => {
    const targetIndex = checkedLineIds.value.findIndex((id) => id === targetId);

    targetIndex === -1
      ? checkedLineIds.value.push(targetId)
      : checkedLineIds.value.splice(targetIndex, 1);
  };

  return {
    checkedLineIds,
    checkedLineCount,
    isPossibleToCheckLine,
    isPossibleToShowLinePath,
    handleCheckLineInfoRow,
  };
};
